import CountUp from "react-countup";

const Count = ({ numToCount }: { numToCount: number }) => {
  return (
    <div>
      <CountUp end={numToCount} duration={5} />
    </div>
  );
};

export default Count;
